<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="新增单位"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 :style="{width: form_width,margin: '20px auto 0 auto'}" autocomplete="off">
            <el-form-item label="单位全称" prop="hospital_name">
                <el-input type="text" v-model="ruleForm.hospital_name" placeholder="请输入单位全称" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="单位别名">
                <el-input type="text" v-model="ruleForm.hospital_nick_name" placeholder="请输入单位别名" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="所属区域" prop="distinct_id">
                <el-cascader
                        v-model="ruleForm.distinct_id"
                        :options="allRegion" placeholder="请选择所属区域" style="width: 100%;"></el-cascader>
            </el-form-item>
            <el-form-item label="运营负责公司" prop="company_id">
                <el-select @change="changeCompany" v-model="ruleForm.company_id" placeholder="请选择运营负责公司"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allCompany"
                        :key="item.id"
                        :label="item.company_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="运营负责部门">
                <el-select @change="changeDeparment" v-model="ruleForm.department_id"
                           placeholder="请选择运营负责部门"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allCompanyDeparment"
                        :key="item.id"
                        :label="item.department_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="运营负责组">
                <el-select v-model="ruleForm.group_id" @change="changeGroup" placeholder="请选择运营负责组"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allCompanyGroup"
                        :key="item.id"
                        :label="item.group_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="特属服务专员">
                <el-select v-model="ruleForm.operate_user_ids"
                           multiple
                           placeholder="请选择特属服务专员"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allGroupUser"
                        :key="item.id"
                        :label="item.user_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="排序号" prop="sort">
                <el-input type="number" v-model="ruleForm.sort" placeholder="请输入排序号 (排序值越小越前)" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="单位图标(APP)">
                <el-input type="hidden" v-model="ruleForm.thumb" placeholder="单位图标"
                          style="width: 100%;"></el-input>
                <el-upload
                    class="avatar-uploader"
                    :action="upload_path"
                    accept=".png,.PNG"
                    :show-file-list="false"
                    :on-success="handleImgSuccess"
                    :before-upload="beforeAvatarUpload">
                    <img style=" width: 316px;height: 120px;" v-if="imageUrl" :src="imageUrl"
                         class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div>请上传jpg/png格式的单位图标</div>
            </el-form-item>
            <el-form-item label="单位图标(PC)">
                <el-input type="hidden" v-model="ruleForm.thumb_pc" placeholder="单位图标"
                          style="width: 100%;"></el-input>
                <el-upload
                    class="avatar-uploader avatar-uploader_pc"
                    :action="upload_path"
                    accept=".png,.PNG"
                    :show-file-list="false"
                    :on-success="handleImgSuccessPC"
                    :before-upload="beforeAvatarUpload">
                    <img style=" width: 90px;height: 200px;" v-if="imageUrlPC" :src="imageUrlPC"
                         class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon_pc"></i>
                </el-upload>
                <div>请上传jpg/png格式的单位图标</div>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-radio-group v-model="ruleForm.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="2">停用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import env from "@/api/env";
    import {getUserInfos} from '@/utils/userInfos';
    import {check} from "@/utils/checkData";
    import {isMobile} from "@/api/order";

    export default {
        created() {
            if (isMobile()) {
                this.form_width = "100%"
            }
        },
        mounted() {
            this.createParams();
            this.createCompanyParams();
        },
        data() {
            return {
                allRegion: [],
                upload_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=1',
                imgUrl: env.IMG_COMMON_URL_PREFIX,
                imageUrl: '',
                imageUrlPC: '',
                allCompany: [],
                allCompanyDeparment: [],
                allCompanyGroup: [],
                allGroupUser: [],
                ruleForm: {
                    distinct_id: "",
                    hospital_name: "",
                    hospital_nick_name: "",
                    sort: "10",
                    status: 1,
                    thumb: '',
                    thumb_pc: '',
                    company_id: '',
                    department_id: '',
                    group_id: '',
                    operate_user_id: '',
                    operate_user_ids: [],
                },
                rules: {
                    hospital_name: [
                        {required: true, message: "请输入单位全称", trigger: "blur"},
                    ],
                    distinct_id: [
                        {required: true, message: "请选择区域", trigger: "blur"},
                    ],
                    sort: [
                        {required: true, message: "请输入排序号", trigger: "blur"},
                    ],
                    status: [
                        {required: true, message: "请选择状态", trigger: "blur"},
                    ],
                },
                is_submit: false,
                form_width: "40%",
            };
        },
        methods: {
            // 所有地区
            createParams() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'allRegion',
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allRegion = res.data.data;
                });
            },
            // 所有运营单位
            createCompanyParams() {
                let params = {
                    servername: 'Ruyi_AdminNewOperateServices',
                    method: 'createParams',
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allCompany = res.data.data.company;

                    if (this.role_id == 3) {
                        this.ruleForm.company_id = this.userData.company_id
                        this.changeCompany()
                    }
                });
            },
            // 返回上一页
            goBack() {
                window.history.go(-1);
                // this.$router.push({
                //     name: "hospitalList",
                //     params: {}
                // });
                // window.close()
            },

            // 提交表单
            submitForm(formName) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复提交',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let _that = this
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let params = {
                            'servername': 'Ruyi_AdminOperateServices',
                            'method': 'createHospital',
                            'params': {
                                hospital_name: this.ruleForm.hospital_name,
                                hospital_nick_name: this.ruleForm.hospital_nick_name,
                                sort: this.ruleForm.sort,
                                status: this.ruleForm.status,
                                thumb: this.ruleForm.thumb,
                                thumb_pc: this.ruleForm.thumb_pc,
                                province_id: this.ruleForm.distinct_id[0],
                                city_id: this.ruleForm.distinct_id[1],
                                distinct_id: this.ruleForm.distinct_id[2],
                                company_id: this.ruleForm.company_id,
                                department_id: this.ruleForm.department_id,
                                group_id: this.ruleForm.group_id,
                                operate_user_ids: this.ruleForm.operate_user_ids,
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                this.is_submit = false;
                                return;
                            }
                            this.$message({
                                type: "success",
                                message: '创建成功',
                                duration: 1500,
                                onClose: function () {
                                    // window.history.go(-1);
                                    _that.is_submit = false;
                                    _that.$router.push({
                                        name: "hospitalList",
                                        params: {}
                                    });
                                }
                            });
                        }).catch(()=>{
                            this.is_submit = false;
                        }).finally(() => {
                            this.is_submit = false;
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: '请输入必填项'
                        });
                        this.is_submit = false;
                        return false;
                    }
                });
            },
            handleImgSuccess(res) {
                if (res.code == 0) {
                    this.ruleForm.thumb = res.data;
                    this.imageUrl = this.imgUrl + res.data;
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            },
            handleImgSuccessPC(res) {
                if (res.code == 0) {
                    this.ruleForm.thumb_pc = res.data;
                    this.imageUrlPC = this.imgUrl + res.data;
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            },
            //上传图片之前，检测文件格式
            beforeAvatarUpload(file) {
                if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf') {
                    var isJPG = true;
                } else {
                    var isJPG = false;
                }
                if (!isJPG) {
                    this.$message.error('图片只能是jpg/png/pdf格式!');
                }
                return isJPG;
            },
            changeCompany() {
                this.ruleForm.department_id = '';
                this.ruleForm.group_id = '';
                this.getAllDeparment();
            },
            changeDeparment() {
                this.ruleForm.group_id = '';
                this.getAllCompanyGroup();
            },
            getAllDeparment() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'getAllCompanyDeparment',
                    params: {
                        company_id: this.ruleForm.company_id,
                        status: 1
                    }
                };
                this.allCompanyDeparment = [];
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allCompanyDeparment = res.data.data;
                });
            },

            getAllCompanyGroup() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'getAllCompanyGroup',
                    params: {
                        company_id: this.ruleForm.company_id,
                        department_id: this.ruleForm.department_id,
                        status: 1
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allCompanyGroup = res.data.data;
                });
            },
            // 获取组成员
            changeGroup() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'getAllGroupUser',
                    params: {
                        company_id: this.ruleForm.company_id,
                        department_id: this.ruleForm.department_id,
                        group_id: this.ruleForm.group_id,
                        status: 1
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allGroupUser = res.data.data;
                });
            },
        }

    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";


    .editor {
        line-height: normal !important;
        height: 800px;
    }

    .avatar-btn, .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 316px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }
    .avatar-uploader-icon_pc{
        font-size: 28px;
        color: #8c939d;
        width: 90px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
    .el-upload.el-upload--text{
        width: 316px !important;
        height: 120px !important;
    }
    .avatar-uploader_pc {
        .el-upload.el-upload--text{
            width: 90px !important;
            height: 200px !important;
        }
    }
    .ql-snow .ql-tooltip[data-mode=link]::before {
        content: "请输入链接地址:";
    }

    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
        border-right: 0px;
        content: '保存';
        padding-right: 0px;
    }

    .ql-snow .ql-tooltip[data-mode=video]::before {
        content: "请输入视频地址:";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
        content: '14px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
        content: '10px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
        content: '18px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
        content: '32px';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
        content: '文本';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
        content: '标题1';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
        content: '标题2';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
        content: '标题3';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
        content: '标题4';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
        content: '标题5';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
        content: '标题6';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
        content: '标准字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
        content: '衬线字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
        content: '等宽字体';
    }
</style>
